import { format, parseISO } from 'date-fns';

/**
 * Format a date string for display, handling both ISO date strings and datetime strings.
 * Parses the date in local timezone to avoid timezone conversion issues.
 *
 * @param dateString - ISO date string (e.g., "2025-11-12" or "2025-11-12T00:00:00Z")
 * @returns Formatted date string (e.g., "11/12/2025") or "-" if null
 *
 * @example
 * formatDate("2025-11-12") // "11/12/2025"
 * formatDate("2025-11-12T00:00:00Z") // "11/12/2025"
 * formatDate(null) // "-"
 */
export const formatDate = (dateString: string | null): string => {
  if (!dateString) return '-';

  // Extract date part (handles both "2025-11-12" and "2025-11-12T00:00:00Z")
  const [datePart] = dateString.split('T');

  // parseISO handles ISO date strings and creates a local date
  const date = parseISO(datePart);

  return format(date, 'MM/dd/yyyy');
};
